import { render, staticRenderFns } from "./EditSeller.vue?vue&type=template&id=72a0fd88&"
import script from "./EditSeller.vue?vue&type=script&lang=js&"
export * from "./EditSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports